// extracted by mini-css-extract-plugin
export default {"link":"NavItem_link__jpoxi","text":"NavItem_text__Pbkvy","iconWrapper":"NavItem_iconWrapper__lqdLE","active":"NavItem_active__OrJcc"};